module.exports = __webpack_public_path__ + "static/media/dieu-kien-tien-nghi-active.9a1d1aa1.svg";